import { useEffect } from 'react';

import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import {
  PageValues,
  usePageContext,
} from '@providers/PageMetaProvider/model/PageContext';
import MultiDocumentAgentTable from '@features/admin-multi-document-agent/containers/MultiDocumentAgentTable';

const pageValues: PageValues = {
  title: 'Multi-Document Agent',
};

function MultiDocumentAgentPage() {
  usePageTitle('ZlaytAI - Multi-Document Agent');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...pageValues,
        // preserve any generating modals that may have been opened prior to navigation
        generateModalOpened: prev?.generateModalOpened,
        generateTemplateModalOpened: prev?.generateTemplateModalOpened,
        generateDepositionSummaryModalOpened:
          prev?.generateDepositionSummaryModalOpened,
        generateUseCaseModalOpened: prev?.generateUseCaseModalOpened,
      }));
    }
  }, []);

  return <MultiDocumentAgentTable />;
}

export default MultiDocumentAgentPage;
